import { FFmpeg } from '@ffmpeg/ffmpeg';
import { fetchFile } from '@ffmpeg/util';

const ffmpeg = new FFmpeg();

// addMetadataWithFFmpeg.js
export default async function addMetadataWithFFmpeg(blob) {
    return blob; // Simple passthrough for now
}